import { Module } from 'vuex';

import { reportsService } from '@/services/reports/reports.service';
import { Report } from '@/services/reports/reports.types';
import { RootState } from '@/store';
// import axios from 'axios';

export interface ReportsState {
  reports: Report[];
  reportLoading: boolean;
}

const state: ReportsState = {
  reports: [],
  reportLoading: false
};

const options: Module<ReportsState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    saveReport: ({ commit, dispatch }, options: { report_id: number; language: string }): Promise<void> => {
      commit('reportLoading', true);
      const { report_id, language } = options;
      return reportsService
        .downloadReport(report_id, language)
        .then(report => report && dispatch('file/saveBase64As', report, { root: true }))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('reportLoading', false));
    },
    generateNewReport: ({ commit, dispatch }, { serial_no, step, additional_tests, shipping_date }): Promise<void> => {
      commit('reportLoading', true);

      const additionalTestsParams = step == 'repair' ? additional_tests : undefined;
      return reportsService
        .createReport(serial_no, step, additionalTestsParams, shipping_date)
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('reportLoading', false));
    },
    getReports: ({ commit, dispatch }, serial_no: string): Promise<void> => {
      commit('reportLoading', true);
      return reportsService
        .list(serial_no)
        .then(reports => reports && commit('reports', reports))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('reportLoading', false));
    },
    PrintSavReport: ({ commit, dispatch }, options: { report_id: number; language: string }): Promise<void> => {
      commit('reportLoading', true);
      const { report_id, language } = options;
      return reportsService
        .downloadReport(report_id, language)
        .then(report => {
          Promise.all([
            report &&
              dispatch(
                'printer/printWith',
                { data: [{ type: 'pdf', format: 'base64', data: report.base_64 }] },
                { root: true }
              ),
            dispatch('alert/pushInfo', 'Impression du rapport ...', { root: true })
          ]);
        })
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('reportLoading', false));
    }
  },
  mutations: {
    reports: (state, reports: Report[]) => (state.reports = reports),
    reportLoading: (state, loading: boolean) => (state.reportLoading = loading)
  }
};

export default options;
